/**
 * CM
 * 보안 정책
 * 위협 정책
 * TAMS Yara Store
 *
 * @since 2022-07-06
 * @author minsik85.park
 */

import {SecutiryPolicyApiPrefix} from '~/utils/restApi'

const urlPrefix = `${SecutiryPolicyApiPrefix}/ext-dist/tams/yara`

export const state = () => ({
  yaraList: [], // 스노트 프로파일 리스트
  yaraRuleList: [] // 스노트 프로파일별 룰 리스트
})

export const mutations = {
  init (state) {
    state.yaraList = []
    state.yaraRuleList = []
  },
  initYaraList (state, yaraList) {
    state.yaraList = yaraList
  },
  initYaraRuleList (state, yaraRuleList) {
    state.yaraRuleList = yaraRuleList
  }
}

export const actions = {
  // yara 프로파일 리스트 획득
  async getYaraList ({commit}, {loading = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/profile`, {loading})
      if (code === 'ok') {
        commit('initYaraList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 프로파일 추가
  async addYara ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(`${urlPrefix}/profile`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 프로파일 수정
  async updateYara ({state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(`${urlPrefix}/profile/${param.ips_tams_yara_prf_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 프로파일 삭제
  async deleteYara ({state}, yaraID) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$delete(`${urlPrefix}/profile/${yaraID}`, {successAlert: false, loading: false})
      if (code !== 'ok') {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = { code: 'nok', reason: e }
    }
    return res
  },
  // yara 프로파일 동기화 수정
  async setYaraUseYn ({state}, {prfID, param, loading = false, successAlert = false} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(`${urlPrefix}/profile/${prfID}/use`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 정책 리스트 조회
  async getYaraRuleList ({commit}, {prfID, loading = true}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/rule/${prfID}`, {loading})
      if (code === 'ok') {
        commit('initYaraRuleList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 정책 리스트 조회
  async getYaraRule ({commit}, {prfID, ruleID, loading = true}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/rule/${prfID}/${ruleID}`, {loading})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 정책 추가
  async addYaraRule ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(`${urlPrefix}/rule/${param.ips_tams_yara_prf_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 정책 수정
  async updateYaraRule ({state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(`${urlPrefix}/rule/${param.ips_tams_yara_prf_id}/${param.ips_tams_yara_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 정책 삭제
  async deleteYaraRule ({state}, payload) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$delete(`${urlPrefix}/rule/multi`, {data: {ips_tams_yara_item: payload}}, {successAlert: false, loading: false})
      if (code !== 'ok') {
        res = {code: 'nok', reason: result.msg}
      }
      res = result
    } catch (e) {
      res = { code: 'nok', reason: e }
    }
    return res
  },
  // yara 정책 배치 입력
  async addYaraRuleBatch ({commit, state}, {prfId, formData, loading = true, successAlert = false} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(
        `${urlPrefix}/rule/batch/${prfId}`,
        formData, {loading, successAlert, headers: {'Content-Type': 'multipart/form-data'}})
      if (code === 'ok') {
        res.result = result
        if (result.ips_tams_yara_res) {
          res = {code: 'nok', reason: result.ips_tams_yara_res}
        }
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 정책 사용여부 수정
  async setYaraRuleUseYn ({state}, {prfID, ruleID, param, loading = true, successAlert = false} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(`${urlPrefix}/profile/${prfID}/${ruleID}/use`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // yara 설정 취소/적용
  async finalCommand ({state}, type) {
    let res = {code: 'ok'}
    const apiUri = `${urlPrefix}/${type}`,
      axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
    try {
      const result = await this.$axios.$put(apiUri, void 0, axiosConfig)
      res = result
    } catch (e) {
      res = { code: 'nok', result: {msg: e} }
    }
    return res
  }
}
